import gsap, { Power2 } from 'gsap';

const handleScrollButtonClick = () => {
    gsap.to(window, { scrollTo: '#hero-scroll-to-element', ease: Power2.easeInOut, duration: 1.2 });
};

const init = () => {
    const mainInitialVideo = document.querySelector<HTMLVideoElement>('.js-main-initial-video');

    if (mainInitialVideo) {
        mainInitialVideo.disablePictureInPicture = true;

        mainInitialVideo.addEventListener('enterpictureinpicture', async () => {
            gsap.set(mainInitialVideo, { opacity: 0 });
        });

        mainInitialVideo.addEventListener('leavepictureinpicture', () => {
            gsap.set(mainInitialVideo, { opacity: 1 });
        });

        const isMac =
            /(macintosh|macintel|macppc|mac68k|macos)/i.test(navigator.userAgent.toLowerCase()) ||
            /mac/.test(navigator.platform.toLowerCase());

        if (isMac) {
            gsap.set(mainInitialVideo, { filter: 'brightness(0.97)' });
        }
    }

    gsap.fromTo(
        '.js-main-initial-video',
        {
            y: '0vh',
        },
        {
            y: '25vh',
            ease: 'none',
            scrollTrigger: {
                trigger: '.js-main-initial-video-wrapper',
                scrub: true,
                start: 'bottom bottom',
                end: 'bottom top',
            },
        },
    );

    const scrollButton = document.querySelector('.js-main-first-section__scrolldown-btn');

    if (scrollButton) {
        scrollButton.addEventListener('click', handleScrollButtonClick);
    }
};

const destroy = () => {
    const scrollButton = document.querySelector('.js-main-first-section__scrolldown-btn');

    if (scrollButton) {
        scrollButton.removeEventListener('click', handleScrollButtonClick);
    }
};

const _module = { init, destroy };

export default _module;
